// dashboard_index_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bulkCheckbox", "bulkActionsToggler"];

  toggleToggler() {
    const anyCheckboxChecked = this.bulkCheckboxTargets.some(
      checkbox => checkbox.checked
    );

    if (anyCheckboxChecked) {
      this.bulkActionsTogglerTarget.classList.remove('d-none');
    } else {
      this.bulkActionsTogglerTarget.classList.add('d-none');
    }
  }
}